<script setup lang="ts">
/**
 * The Live / On-Demand delivery label — the one rendering every surface uses.
 *
 * Neutral on purpose: delivery mode is neither a state (the semantic variants)
 * nor a content type (the palette variants, which belong to CLE, CPE, …), so it
 * takes no color and the icon tells the two apart. See UX-Specifications.md,
 * "Delivery tags".
 */
import { computed } from 'vue';

interface Props {
  /** `'Live'` or `'OnDemand'`; anything other than `'Live'` reads as on-demand. */
  mode: string;
  /** Surface-specific tooltip, e.g. "Earned by attending the live session". */
  title?: string;
}

const props = defineProps<Props>();

const isLive = computed(() => props.mode === 'Live');
</script>

<template>
  <span class="bb-tag -size-xs -neutral" :title="title">
    <bb-icon :name="isLive ? 'live_tv' : 'play_circle'" decorative></bb-icon>{{ isLive ? 'Live' : 'On-Demand' }}
  </span>
</template>
